module.exports = __webpack_public_path__ + "static/HKGrotesk-Regular-32795d5cd0f16fad9fa2ea82d27007c3.woff2";